import {minmax, sectionToFixedMap, portrait} from '../shared.js';
import {buildNarrativeTextTimeline, drawFrame, createFlipbook, scrubFlipbook} from '../animations.js';

const article = document.querySelector('#chapter4');

const narrativeSection = article.querySelector('#chapter4-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeText = narrativeFixed.querySelector('.narrative-text');
const narrativeTimeline = new TimelineLite({paused: true});

const flipbookSection = article.querySelector('#chapter4-flipbook');
const flipbookFixed = sectionToFixedMap.get(flipbookSection);
const flipbook = flipbookFixed.querySelector('.flipbook');
const tomahawkInfo = flipbookFixed.querySelector('#chapter4-tomahawk-info');
const tomahawks = document.querySelector('#chapter4-tomahawks');
const tomahawk1 = tomahawks.querySelector('img:nth-of-type(1)');
const tomahawk2 = tomahawks.querySelector('img:nth-of-type(2)');
const tomahawk3 = tomahawks.querySelector('img:nth-of-type(3)');
const tomahawk4 = tomahawks.querySelector('img:nth-of-type(4)');
const tomahawk5 = tomahawks.querySelector('img:nth-of-type(5)');
const tomahawksNarrative = flipbookFixed.querySelector('#chapter4-tomahawks-narrative');
const footnote1 = flipbookFixed.querySelector('#chapter4-tomahawk-info-footnote-1');
const footnote2 = flipbookFixed.querySelector('#chapter4-tomahawk-info-footnote-2');
const flipbookTimeline = new TimelineLite({paused: true});

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter4:init');

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initScrub();
}

/**
 * Initialize scrub section
 */
function initScrub() {
  const flipbookStart = 200;
  const flipbookEnd = 600;

  flipbookSection.addEventListener('intersection', () => {
    const create = () => createFlipbook(flipbook, +article.dataset.chapter);
    portrait.addListener(create);
    create();
  }, {once: true});


  flipbookSection.addEventListener('scrub', ({detail: {vh}}) => {
    flipbookTimeline.seek(minmax(0, vh, flipbookTimeline.duration()), false);

    let percent = (vh < flipbookStart) ? 0 : (vh > flipbookEnd) ? 1 : (vh - flipbookStart) / (flipbookEnd - flipbookStart);

    scrubFlipbook(flipbook, percent);
  });

  TweenLite.set([footnote1, footnote2, flipbook, tomahawkInfo], {opacity: 0});
  TweenLite.set(tomahawkInfo, {x: '+=50px'});

  flipbookTimeline.to({}, 150, {});

  flipbookTimeline.to(flipbook, 25, {opacity: 1}, '-=25');

  flipbookTimeline.add([
    TweenLite.to(tomahawkInfo, 50, {
      opacity: 1,
      x: '-=50px',
      ease: Sine.easeOut,
    }),
    TweenLite.to(footnote1, 25, {opacity: 1}),
  ]);

  flipbookTimeline.add([
    TweenLite.to(tomahawkInfo, 50, {
      opacity: 0,
      y: '-=100vh',
      ease: Cubic.easeIn,
    }),
    TweenLite.to(footnote1, 25, {opacity: 0}),
  ], flipbookStart + 75);

  flipbookTimeline.to(flipbook, 25, {opacity: 0}, flipbookEnd);

  flipbookTimeline.to(tomahawk1, 275, {top: '200vh', ease: Sine.easeIn}, flipbookEnd);
  flipbookTimeline.to(tomahawk2, 175, {top: '200vh', ease: Sine.easeIn}, flipbookEnd + 50);
  flipbookTimeline.to(tomahawk3, 175, {top: '200vh', ease: Sine.easeIn}, flipbookEnd + 75);
  flipbookTimeline.to(tomahawk4, 125, {top: '200vh', ease: Sine.easeIn}, flipbookEnd + 100);
  flipbookTimeline.to(tomahawk5, 60, {top: '250vh', ease: Sine.easeIn}, flipbookEnd + 145);

  flipbookTimeline.to(footnote2, 25, {opacity: 1}, '-=100');

  let ts;

  for (const text of tomahawksNarrative.querySelectorAll('div')) {
    TweenLite.set(text, {
      opacity: 0,
      y: '+=50px',
    });

    flipbookTimeline.to(text, 50, {
      opacity: 1,
      y: '-=50px',
      ease: Sine.easeOut,
    }, ts);

    ts = flipbookTimeline.duration();

    flipbookTimeline.to(text, 25, {
      opacity: 0,
      y: '-=100px',
      ease: Sine.easeIn,
    }, ts);

    ts = flipbookTimeline.duration() + 25;
  }
}
